import { ResourceReferenceViewModel} from "./resource-view-model";

export class AokCardViewModel {
    id?: string | undefined;
    title?: string | undefined;
    shortDescription?: string | undefined;
    thumbnail?: ResourceReferenceViewModel | undefined;
    resources : ResourceReferenceViewModel[] | undefined;
    rewardId: number | undefined;
}